import { IUserRepository } from '../repositories/IUserRepository'

export interface ICreateUsuarioRequest {
  nome: string
  email: string
  frotistas_ids: number[]
  telefone: string
  perfil: string
}

export interface ICreateUsuario {
  execute(params: ICreateUsuarioRequest): Promise<void>
}

export default class CreateUsuarioImpl implements ICreateUsuario {
  constructor(private readonly userRepository: IUserRepository) {}

  public async execute(params: ICreateUsuarioRequest): Promise<void> {
    await this.userRepository.createUsuario(params)
  }
}
